export const RootContainerCtrlModel = function (data) {
    if (!data) data = {};
    this.root = data.root || null;
    this.className = data.className || null;
    this.style = data.style || null;
};